import React from 'react';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import type { AccountingExportCompanyLookup } from './accountingExportCompaniesLookupMapper';
import { mapCompanyToAccountingExportLookup } from './accountingExportCompaniesLookupMapper';

export const useGetAccountingExportCompaniesLookupQuery = (): {
  companies: AccountingExportCompanyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetCompaniesQuery();

  const companies = React.useMemo(
    (): AccountingExportCompanyLookup[] =>
      (data ?? [])
        .map(mapCompanyToAccountingExportLookup)
        .filter((item): item is AccountingExportCompanyLookup => item !== undefined)
        .sort((a, b) => a.name.localeCompare(b.name, 'pl')),
    [data]
  );

  return {
    companies,
    isLoading,
  };
};
